import { useState } from 'react'
import { toast } from 'sonner'

import {
  PreferenceCategory,
  PreferenceInfo,
  PreferenceInput,
  PreferenceScreen,
  PreferenceSubmit,
} from '../../components/Preference'
import { authClient, useMe } from '../../lib/auth-client'

export default function EmailSettings() {
  const { data: me } = useMe()
  const [newEmail, setNewEmail] = useState('')
  const [busy, setBusy] = useState(false)

  async function saveEmail() {
    setBusy(true)
    try {
      const { error: err } = await authClient.changeEmail({
        newEmail: newEmail.trim(),
        callbackURL: '/settings/account',
      })
      if (err) {
        toast.error(err.message || 'E-mail wijzigen mislukt')
        return
      }
      setNewEmail('')
      toast.success('Bevestiging verstuurd', {
        description:
          'Check je huidige inbox om de wijziging te bevestigen. Daarna bevestig je het nieuwe adres.',
      })
    } finally {
      setBusy(false)
    }
  }

  return (
    <PreferenceScreen title="E-mailadres" backHref="/settings/account">
      <PreferenceCategory filled>
        <PreferenceInfo
          title="Huidig e-mailadres"
          summary={me?.user?.email || '—'}
        />
        <PreferenceInput
          title="Nieuw e-mailadres"
          type="email"
          value={newEmail}
          onChange={setNewEmail}
          placeholder="nieuw@voorbeeld.be"
          autoComplete="email"
        />
        <PreferenceSubmit
          title="E-mail wijzigen"
          onPress={saveEmail}
          disabled={
            busy || !newEmail.trim() || newEmail.trim() === me?.user?.email
          }
        />
      </PreferenceCategory>
    </PreferenceScreen>
  )
}
